export default __webpack_public_path__ + "static/media/In-Progress.84a576f4.gif";